import { areaService } from '../../helpers/area.service';

export const actions = {
    allArea({ dispatch, commit }) {
        return new Promise((resolve, reject) => {
            areaService.getAll().then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
}

export const mutations = {

};

function _handleError(error) {
    var errorMessage = error.response ? error.response.statusText : error;
    return errorMessage;
};